import type { ProgressState, StepsGroup } from './types';

type Progression = {
  status: ProgressState;
  label: React.ReactNode;
};

export const getSortedIndicators = <Step extends string>(
  currentStep: Step,
  steps: readonly Step[],
  stepsGroups: StepsGroup<Step>[],
): Progression[] => {
  if (steps === undefined) {
    return [];
  }

  const indexOfCurrentStep = steps.indexOf(currentStep);

  if (indexOfCurrentStep === -1) {
    return stepsGroups.map(({ label }, index) => {
      return {
        status: index === 0 ? 'active' : 'unvisited',
        label,
      };
    });
  }

  const stepsUpToCurrentStep = steps.slice(0, indexOfCurrentStep + 1);
  let stepIndex = 0;
  let activeStepFound = false;
  return stepsGroups.reduce<Progression[]>((acc, { label, firstStepOfTheNextGroup }) => {
    while (stepIndex < stepsUpToCurrentStep.length) {
      const isFinished = stepsUpToCurrentStep[stepIndex] === firstStepOfTheNextGroup;
      if (isFinished) {
        acc.push({
          status: 'finished',
          label,
        });
        return acc;
      }
      stepIndex++;
    }
    if (!activeStepFound) {
      activeStepFound = true;
      acc.push({
        status: 'active',
        label,
      });
    } else {
      acc.push({
        status: 'unvisited',
        label,
      });
    }
    return acc;
  }, []);
};
